<template>
  <div class="dashboard">
    <navComponent />
    <div class="container-fluid" style="width: 95%;">
      <div class="row">
        <div class="col-12 col-md-3 rounded">
          <div class="card">
            <sideBar class="d-none d-md-block"></sideBar>
          </div>
        </div>
        <div class="col-12 col-md-9">
          <div class="card">
            <!-- Bottom Navigation for Mobile View  -->
            <div class="hidden-xs hidden-sm-up" v-if="isMobile">
              <home class="container-fluid" v-show="home && isMobile"></home>
              <events class="container-fluid" v-show="event && isMobile"></events>
              <profile class="container-fluid" v-show="profile && isMobile"></profile>
              <sideBar class="container-fluid" v-show="organization && isMobile"></sideBar>
              <v-bottom-navigation
                v-show="isMobile"
                dark
                shift
                grow
                style="position:fixed;bottom: 0;height: auto;z-index: 16"
              >
                <v-btn style="background-color: #ffb229;height: 60px;font-size: .6em;font-weight: 800" @click="showHome">
                  <span>Home</span>
                  <v-icon>mdi-home</v-icon>
                </v-btn>

                <v-btn style="background-color: #ffb229;height: 60px;font-size: .6em;font-weight: 800" @click="showEvent">
                  <span>Events</span>
                  <v-icon>fas fa-calendar</v-icon>
                </v-btn>

                <v-btn style="background-color: #ffb229;height: 60px;font-size: .6em;font-weight: 800" @click="showOrganization">
                  <span>Organization</span>
                  <v-icon>fas fa-sitemap</v-icon>
                </v-btn>

                <v-btn style="background-color: #ffb229;height: 60px;font-size: .6em;font-weight: 800" @click="showProfile">
                  <span>Profile</span>
                  <v-icon>fas fa-user-alt</v-icon>
                </v-btn>
                
              </v-bottom-navigation>
            </div>
            <!--  -->
            <v-tabs
              v-model="tab"
              background-color="deep-purple accent-4"
              class="elevation-2 d-none d-md-block"
              dark
              :grow="true"
              :icons-and-text="true"
            >
              <v-tabs-slider></v-tabs-slider>

              <v-tab key="home" :href="`#home`" style="color: #FFB229">
                Home
                <v-icon color="#FFB229">fas fa-home</v-icon>
              </v-tab>
              <v-tab key="events" :href="`#events`" style="color: #FFB229">
                Events
                <v-icon color="#FFB229">fas fa-calendar</v-icon>
              </v-tab>
              <v-tab key="profile" :href="`#profile`" style="color: #FFB229">
                Profile
                <v-icon color="#FFB229">fas fa-user-alt</v-icon>
              </v-tab>

              <v-tab-item key="home" value="home">
                <v-card flat tile style="background: #000;color: #fff">
                  <home class="container-fluid"></home>
                </v-card>
              </v-tab-item>
              <v-tab-item key="events" value="events">
                <v-card flat tile style="background: #000;color: #fff">
                  <events class="container-fluid"></events>
                </v-card>
              </v-tab-item>
              <v-tab-item key="profile" value="profile">
                <v-card flat tile style="background: #000;color: #fff">
                  <profile class="container-fluid"></profile>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import navComponent from "@/components/dashboard/nav.vue";
import sideBar from "@/components/dashboard/side-bar.vue";
import home from "@/components/dashboard/home.vue";
import events from "@/components/dashboard/events.vue";
import profile from "@/components/dashboard/profile.vue";

export default {
  name: "dashboard",
  data() {
    return {
      tab: null,
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      tabs: 3,
      user: { is_admin: false },
      upcomingEvents: [],
      teams: [],
      events: [],
      registered_user_count: 0,
      home: true,
      event: false,
      profile: false,
      attendees: false,
      organization: false,
      windowWidth: window.innerWidth,
    };
  },
  components: {
    navComponent,
    sideBar,
    home,
    events,
    profile,
  },
  created() {
    this.user = JSON.parse(localStorage.getItem("user_info"));
    if (this.user === null) {
      this.$router.push("/");
    }
    this.teamMembers();
    this.eventList();
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
    });
  },
  computed: {
    isMobile() {
      return this.windowWidth < 768;
    },
  },
  methods: {
    showHome() {
      this.home = true;
      this.event = false;
      this.profile = false;
      this.attendees = false;
      this.organization = false;
    },
    showEvent() {
      this.home = false;
      this.event = true;
      this.profile = false;
      this.attendees = false;
      this.organization = false;
    },
    showProfile() {
      this.home = false;
      this.event = false;
      this.profile = true;
      this.attendees = false;
      this.organization = false;
    },
    showAttendees() {
      this.home = false;
      this.event = false;
      this.profile = false;
      this.attendees = true;
      this.organization = false;
    },
    showOrganization() {
      this.home = false;
      this.event = false;
      this.profile = false;
      this.attendees = false;
      this.organization = true;
    }
  },
};
</script>

<style scoped></style>
